<script lang="ts" module>
	import { splitErrors } from "@-/toolbox/promise.js";
	import { untrack } from "svelte";

    export const toastErrors = <T>(promises: PromiseSettledResult<T>[]) => {
      const {ok, err} = splitErrors(promises);

      for (const e of err) toastError(e!);

      return ok;
    };

    export const toastError = (e: NonNullable<unknown>) => {
      let msg = e instanceof Error ? e.name + " " + e.message : undefined;

      // TODO: pl-api thing, replace when replacing it
      if ("response" in e) {
        msg = e.response.json.error + ": " + e.response.json.message
      }

      untrack(() => toasts.push({type: "err", msg }))
    }

    interface Toast {
      type: "err",
      msg: string,
    }

    const toasts = $state<Toast[]>([]);
</script>

<script lang="ts"></script>

<div class="_root">
    {#each toasts as toast}
        <div class="_toast _{toast.type}">{toast.msg}</div>
    {/each}
</div>

<style>
    ._root {
        position: fixed;
        inset-block-end: 0;
        inset-inline-start: 0;
    }

    ._toast {
        margin-block-end: var(--s-xs);
        margin-inline-start: var(--s-xs);
        padding: var(--s-xs);
        border-radius: var(--rad-2);

        background: var(--g-light) var(--_toast-color);
        box-shadow: var(--shadow-panel-container);
    }

    ._err {
        --_toast-color: oklch(from var(--c-base) calc(l * .8) c 0deg);
    }
</style>
